import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, ArrowRight } from 'lucide-react';
const OFFERS = [{
  id: 'kit',
  name: 'KIT SESIONES CLÍNICAS',
  oldPrice: '$49.990',
  price: '$19.990',
  url: 'https://checkout.sectordigital.online/cart/43948465389611:1',
  badge: null,
  image: null,
  items: ['Método SESIÓN 4F', 'Pack de Plantillas Clínicas', <span key="b1" data-id="element-76">
        <strong data-id="element-77">BONUS:</strong> 50 Intervenciones Clínicas Rápidas
      </span>, <span key="b2" data-id="element-78">
        <strong data-id="element-79">BONUS:</strong> Guía Express Primera Sesión
      </span>]
}, {
  id: 'combo',
  name: 'KIT SESIONES CLÍNICAS + PSICÓLOGO CON AGENDA LLENA',
  oldPrice: '$69.990',
  price: '$29.990',
  url: 'http://checkout.sectordigital.online/cart/43952651534379:1',
  badge: '⭐ MÁS ELEGIDA',
  image: 'https://cdn.magicpatterns.com/uploads/x8g4ifxzMBJZM2imaW6w3z/Diseno_sin_titulo_(17).png',
  items: ['Todo el KIT Sesiones Clínicas', 'Método SESIÓN 4F', 'Pack de Plantillas Clínicas', 'Psicólogo con Agenda Llena (curso completo)', <span key="b1" data-id="element-80">
        <strong data-id="element-81">BONUS:</strong> 50 Intervenciones Clínicas Rápidas
      </span>, <span key="b2" data-id="element-82">
        <strong data-id="element-83">BONUS:</strong> Guía Express Primera Sesión
      </span>]
}];
export const PricingSection: React.FC = () => {
  const [selected, setSelected] = useState('combo');
  const selectedOffer = OFFERS.find(o => o.id === selected)!;
  return <section id="comprar" className="py-10 md:py-20 px-4 bg-navy-800 relative" data-id="element-84">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-navy-700 via-navy-800 to-navy-900" data-id="element-85"></div>

      <div className="max-w-md md:max-w-4xl mx-auto relative z-10" data-id="element-86">
        <div className="text-center mb-6 md:mb-10" data-id="element-87">
          <h2 className="text-xl md:text-4xl font-bold mb-2 md:mb-4 text-white" data-id="element-88">
            TODO LO QUE NECESITÁS PARA TRABAJAR MEJOR COMO PSICÓLOGO/A
          </h2>
          <p className="text-sm md:text-xl text-gray-400" data-id="element-89">
            Un solo pago. Sin suscripciones. Tuyo para siempre.
          </p>
        </div>

        {/* Offer Cards */}
        <div className="grid md:grid-cols-2 gap-3 md:gap-5 mb-5 md:mb-8" data-id="element-90">
          {OFFERS.map(offer => {
          const isSelected = selected === offer.id;
          return <motion.div key={offer.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} onClick={() => setSelected(offer.id)} className={`relative cursor-pointer rounded-xl md:rounded-2xl border-2 overflow-hidden transition-all duration-300 ${isSelected ? 'border-gold-500 shadow-[0_0_25px_rgba(201,168,76,0.2)]' : 'border-navy-600 opacity-60 hover:opacity-85'}`} data-id="element-91">
                {/* Badge */}
                {offer.badge && <div className="bg-gold-500 text-navy-900 text-center py-1.5 font-bold text-xs md:text-sm tracking-wider" data-id="element-92">
                    {offer.badge}
                  </div>}

                <div className="bg-navy-900 p-4 md:p-6" data-id="element-93">
                  {/* Selection indicator + title */}
                  <div className="flex items-start gap-2.5 mb-3" data-id="element-94">
                    <div className={`w-4 h-4 mt-0.5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${isSelected ? 'border-gold-500' : 'border-gray-500'}`} data-id="element-95">
                      {isSelected && <div className="w-2 h-2 rounded-full bg-gold-500" data-id="element-96"></div>}
                    </div>
                    <h3 className="text-sm md:text-lg font-extrabold text-white leading-tight" data-id="element-97">
                      {offer.name}
                    </h3>
                  </div>

                  {/* Offer image */}
                  {offer.image && <div className="flex justify-center mb-3" data-id="element-98">
                      <img src={offer.image} alt={offer.name} className="h-24 md:h-32 object-contain drop-shadow-lg" data-id="element-99" />
                    </div>}

                  {/* Items */}
                  <ul className="space-y-1.5 mb-4" data-id="element-100">
                    {offer.items.map((item, i) => <li key={i} className="flex items-center gap-2 text-xs md:text-sm text-gray-200" data-id="element-101">
                        <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-500 shrink-0" data-id="element-102" />
                        <span data-id="element-103">{item}</span>
                      </li>)}
                  </ul>

                  {/* Price */}
                  <div className="text-center" data-id="element-104">
                    <p className="text-gray-400 line-through text-sm md:text-lg" data-id="element-105">
                      {offer.oldPrice}
                    </p>
                    <p className="text-3xl md:text-4xl font-extrabold text-gold-500" data-id="element-106">
                      {offer.price}{' '}
                      <span className="text-sm md:text-lg" data-id="element-107">ARS</span>
                    </p>
                    <p className="text-[10px] md:text-xs text-gray-400 mt-0.5" data-id="element-108">
                      Pago único · Sin cargos ocultos
                    </p>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>

        {/* Shared CTA Button */}
        <div className="max-w-sm md:max-w-md mx-auto" data-id="element-109">
          <motion.a href={selectedOffer.url} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="bg-gold-500 hover:bg-gold-400 text-navy-900 font-bold py-3.5 md:py-4 px-6 md:px-8 rounded-full shadow-[0_0_20px_rgba(201,168,76,0.4)] transition-all duration-300 flex items-center justify-center gap-2 text-base md:text-xl w-full text-center" data-id="element-110">
            SÍ, QUIERO EL KIT AHORA
            <ArrowRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-111" />
          </motion.a>

          <div className="mt-4 flex items-center justify-center gap-4 text-[10px] md:text-sm text-gray-400" data-id="element-112">
            <div className="flex items-center gap-1 md:gap-2" data-id="element-113">
              <ShieldCheck className="w-3.5 h-3.5 md:w-5 md:h-5 text-gold-500" data-id="element-114" />
              <span data-id="element-115">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-1 md:gap-2" data-id="element-116">
              <ShieldCheck className="w-3.5 h-3.5 md:w-5 md:h-5 text-gold-500" data-id="element-117" />
              <span data-id="element-118">Garantía 7 días</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
};